import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";

const StatsTable = ({
  title,
  columns,
  subColumns = null,
  rows,
  loading = false,
  className = "col-md-12 col-lg-6",
}) => {
  if (loading) {
    return (
      <div className={`table-responsive ${className}`}>
        <table className="table table-bordered statistic-table">
          <thead>
            <tr>
              <th colSpan={columns.length}>{title}</th>
            </tr>
          </thead>
          <tbody className="text-center">
            <tr>
              <td colSpan={columns.length}>
                <FontAwesomeIcon icon={["far", "spinner"]} pulse size="lg" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className={`table-responsive ${className}`}>
      <table className="table table-bordered statistic-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.id || col.header}
                scope="col"
                rowSpan={col.rowSpan}
                colSpan={col.colSpan}
                className={col.className}
              >
                {col.header}
              </th>
            ))}
          </tr>
          {subColumns && (
            <tr>
              {subColumns.map((col) => (
                <th
                  key={col.id || col.header}
                  scope="col"
                  className={col.className}
                >
                  {col.header}
                </th>
              ))}
            </tr>
          )}
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.period}>
              <th scope="row">{row.period}</th>
              {row.values.map((item) => (
                <td key={item.id} className="text-center">
                  {item.value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

StatsTable.propTypes = {
  title: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      id: PropTypes.string,
      colSpan: PropTypes.number,
      rowSpan: PropTypes.number,
      className: PropTypes.string,
    }),
  ).isRequired,
  subColumns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      id: PropTypes.string,
      className: PropTypes.string,
    }),
  ),
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      period: PropTypes.string.isRequired,
      values: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
      ).isRequired,
    }),
  ).isRequired,
  loading: PropTypes.bool,
  className: PropTypes.string,
};

export default React.memo(StatsTable);
